var React = require('react');

function Component (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.25 1V0.695079L25.951 0.75485C21.0073 1.74309 17.5205 4.18958 14.8354 7.90832L13.5385 9.60653L12.3491 7.91366L12.3439 7.90626L12.3382 7.89925C9.35964 4.25171 5.87801 1.68637 1.04735 0.754526L0.75 0.697165V1V3.92623V4.11029L0.925756 4.16495C6.76896 5.98223 10.7223 9.37057 12.0822 15.0581L12.128 15.25H12.3253H14.494H14.6887L14.7364 15.0612C16.2153 9.20115 20.2284 5.92625 26.0721 4.1656L26.25 4.11201V3.92623V1Z","fill":"currentColor","stroke":"currentColor","strokeWidth":"0.5"}));
}

Component.defaultProps = {"width":"27","height":"16","viewBox":"0 0 27 16","fill":"none"};

module.exports = Component;

Component.default = Component;
